import Axios from "axios";
import {
    SET_DIVISION_LIST,
    UNSET_DIVISION_LIST,
} from "@/store/mutation-types";
import { getDivisionList } from "@/store/api";

// initial state
const state = {
    getDivisionList: [],
};

const getters = {
    getDivisionList(state) {
        return state.getDivisionList;
    }
};

const mutations = {
    [SET_DIVISION_LIST](state, data) {
        state.getDivisionList = data;
    },
    [UNSET_DIVISION_LIST](state) {
        state.getDivisionList = [];
    }
};

const actions = {
    getDivisionList({ commit }) {
        return new Promise((resolve, reject) => {
            Axios.get(getDivisionList)
                .then(function (response) {
                    // Handle different response structures
                    let data = response.data;
                    if (data && data.data) {
                        data = data.data; // If response is wrapped in {data: [...]}
                    }
                    if (!Array.isArray(data)) {
                        data = []; // Ensure it's always an array
                    }
                    commit('SET_DIVISION_LIST', data);
                    resolve(response);
                })
                .catch(function (error) {
                    console.error('Error loading divisions:', error);
                    commit('UNSET_DIVISION_LIST');
                    reject(error);
                });
        });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
